import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  // console.log(pathname);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: pathname.includes("article/") ? "instant" : "smooth",
    });
  }, [pathname]);

  return null; // No UI rendering needed
};
